module.exports = __webpack_public_path__ + "static/media/img-destaque-home.60a5bf47.jpg";